import type { MailInvitationParticipation } from 'src/types/mailInvitation';

import { AbstractCommand } from 'src/models/command';

export class RespondToTheMailInvitationCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_RespondToTheMailInvitationCommand';

	constructor(
		aggregateId: string,
		mailId: number,
		invitationId: number,
		sendingAccountId: number,
		participation: MailInvitationParticipation
	) {
		super();
		this.parameters = {
			aggregateId,
			invitationId,
			mailId,
			participation,
			sendingAccountId,
		};
	}
}
